import React from 'react';
import Header from '../Header';
import AsideBar from '../AsideBar';
import Footer from '../Footer';

function CreateFolder() {
    return (
        <div>
            <Header />
            <AsideBar />
            <section id="main-content">
                <section class="wrapper">
                </section>
            </section>
            <Footer />
        </div>
    );
}

export default CreateFolder;